// extracted by mini-css-extract-plugin
module.exports = {"smooth_background":"styles_smooth_background__17NRt"};